import React, { forwardRef } from 'react'

const hasContent = children =>
  React.Children.toArray(children).length > 0

const InvalidForm = ({ children, className }, ref) =>
  hasContent(children) &&
  <div
    ref={ref}
    className={[ 'alert alert-danger', className ].filter(Boolean).join(' ')}
    role="alert"
  >
    {children}
  </div>

export default forwardRef(InvalidForm)
